module.exports = __webpack_public_path__ + "static/img/light.8009af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/light.png
// module id = y4mb
// module chunks = 0